<button *ngIf="!btnOption.showImg" type="button"
    [ngClass]="{'button-right': btnOption.alignment === 'right',
     'mat-back-button': btnOption.type === 'back',
      'mat-raised-button': btnOption.type !== 'back', 'full-width': btnOption.fullWidth,
      'fixed-width': btnOption.fixedWidth, 'secondary-btn': btnOption.style === 'secondary'}"
        [disabled]="loading || disabled"
    mat-button id="{{btnOption.formId}}" [color]="btnOption.color" [style.text-decoration]="btnOption.underline"
    (click)="emitEvent()">
    <div>
      <label [for]="btnOption.for" class="lblAlign">{{btnOption.text | translate:btnOption.translateArgs }}</label>
      <div class="button-row">
        <ng-container *cidComponentLoader="loading"></ng-container>
      </div>
    </div>
</button>

<button *ngIf="btnOption.showImg" (click)="emitEvent()" class="img-button" mat-icon-button>
    <label *ngIf="btnOption.type === 'proceed' || !btnOption.type" [for]="btnOption.for">
        <mat-icon>arrow_forward_ios</mat-icon>
    </label>
    <label *ngIf="btnOption.type === 'back'" [for]="btnOption.for">
      <mat-icon>arrow_back_ios</mat-icon>
    </label>
    <ng-container *cidComponentLoader="true" ></ng-container>
</button>
